export default __webpack_public_path__ + "static/iphone-image-f3a56c7203efddf599f4cbcae6563c22.png";